import React from 'react';
import CheckQuizStatus from './CheckQuizStatus';
import { useAptitudeAttemptQuery } from './AptitudeQuizSlice';
import { Navigate } from 'react-router-dom';
import Loading from 'components/global/layout/Loading';
import { useNewAptitudeAttemptQuery } from '../newAptitude/NewAptitudeQuizSlice';
import NewCheckQuizStatus from '../newAptitude/NewCheckQuizStatus';

const CheckAptitudeAttempt = () => {
  const {
    isLoading: oldLoading,
    isSuccess: oldSuccess,
    isError: oldError,
    data: oldData,
  } = useAptitudeAttemptQuery();

  const {
    isLoading: newLoading,
    isSuccess: newSuccess,
    isError: newError,
    data: newData,
  } = useNewAptitudeAttemptQuery();

  const isLoading = oldLoading || newLoading;
  const isError = oldError || newError;

  return (
    <div>
      {isError && <div> Error fetching test status... </div>}
      {isLoading && (
        <div>
          <Loading />{' '}
        </div>
      )}
      {!isLoading &&
        !isError &&
        oldSuccess &&
        oldData &&
        newSuccess &&
        newData && (
          <>
            {!oldData.attemptLeft && !oldData.testInProgress ? (
              <Navigate to='/quiz/aptitude/scorecard' replace />
            ) : !newData.attemptUsed || newData.testInProgress ? (
              <NewCheckQuizStatus />
            ) : (
              <Navigate to='/quiz/new-aptitude/scorecard' replace />
            )}
          </>
        )}
    </div>
  );
};

export default CheckAptitudeAttempt;
